/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs */

const en_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporting dashboards`)
};

const ar_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحات التقارير`)
};

const bn_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিপোর্টিং ড্যাশবোর্ড`)
};

const de_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporting-Dashboards`)
};

const es_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paneles de informes`)
};

const fr_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableaux de bord de reporting`)
};

const pt_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painéis de relatórios`)
};

const zh_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报表看板`)
};

const tr_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapor panoları`)
};

const ru_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дашборды отчётности`)
};

const pl_svc_ecommerce_amazon_tools_dash_title4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboardy raportowe`)
};

/**
* | output |
* | --- |
* | "Reporting dashboards" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_dash_title4 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Dash_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_dash_title4(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_dash_title4(inputs)
	return en_svc_ecommerce_amazon_tools_dash_title4(inputs)
});
export { svc_ecommerce_amazon_tools_dash_title4 as "svc_ecommerce-amazon-tools_DASH_title" }